import React, { useState } from "react";
import "./Auth.css";
import { Link, useNavigate } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { authApi } from "../../api/client";
import { getApiErrorMessage } from "../../api/http";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleSendCode = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);

    try {
      const normalizedEmail = email.trim().toLowerCase();
      const normalizedPhone = phone.trim();

      await authApi.requestPasswordReset({ email: normalizedEmail, phone: normalizedPhone });
      sessionStorage.setItem("ieee_reset_email", normalizedEmail);
      sessionStorage.setItem("ieee_reset_phone", normalizedPhone);
      setMessage("Reset code sent successfully. Check your email.");
      setTimeout(() => navigate("/verify", { state: { email: normalizedEmail, phone: normalizedPhone } }), 700);
    } catch (err) {
      setError(getApiErrorMessage(err, "Unable to send reset code"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Forget Password " subtitle="Please enter your details to assign a new password">
      <h2 className="fw-bold text-center mb-4">Forget Password</h2>
      <form onSubmit={handleSendCode}>
        <div className="mb-4">
          <label className="form-label">Email</label>
          <input
            type="email"
            className="form-control custom-input placeholdercolor "
            placeholder="Enter Your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="mb-4">
          <label className="form-label">Phone Number</label>
          <input
            type="tel"
            className="form-control custom-input placeholdercolor "
            placeholder="Enter Your Phone Number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
        </div>
        {error ? <div className="alert alert-danger py-2 small">{error}</div> : null}
        {message ? <div className="alert alert-success py-2 small">{message}</div> : null}
        <button disabled={loading} type="submit" className="btn btn-primary w-100 mb-4 fw-bold mt-3 btn-signin">
          {loading ? "Sending..." : "Send Code"}
        </button>
      </form>
      <p className="text-center small">Remember the password? <Link to="/" className="fw-bold text-decoration-none">Go Back</Link></p>
    </AuthLayout>
  );
};

export default ForgotPassword;
